import { Stamp, ArrowRight } from "lucide-react";
import { trackPrinterClick } from "../lib/api";
import { buildPrinterUrl } from "../lib/format";

/** Lien direct vers le configurateur printer.fr (tampon 4914) avec les
 *  coordonnées du client passées en paramètres pour la prévisualisation.
 *  variant: "primary" (CTA fiche) | "row" (raccourci liste de résultats). */
export const StampButton = ({ coordonnees, siren, sourcePage = "fiche-entreprise", variant = "primary" }) => {
  const url = buildPrinterUrl({
    ...(coordonnees || {}),
    siren: coordonnees?.siren || siren,
    modele: "4914",
  });

  const onClick = (e) => {
    e.stopPropagation();
    trackPrinterClick(siren, sourcePage);
  };

  if (variant === "primary") {
    return (
      <a
        data-testid="create-stamp-btn"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-[hsl(var(--brand))] px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-[hsl(var(--brand-hover))]"
      >
        Créer mon tampon
        <ArrowRight className="h-4 w-4" />
      </a>
    );
  }

  return (
    <a
      data-testid={`quick-stamp-${siren}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      title="Créer un tampon avec ces coordonnées"
      className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-[hsl(var(--brand))]/40 bg-[hsl(var(--surface))] px-3 py-1.5 text-xs font-medium text-[hsl(var(--brand))] transition-colors hover:bg-[hsl(var(--brand))] hover:text-white"
    >
      <Stamp className="h-3.5 w-3.5" /> Tampon
    </a>
  );
};

export default StampButton;
